import { Component, AfterViewInit, OnInit } from '@angular/core';
import { MessageclientService } from '../../../../service/messageclient.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Platform } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { WebParameterContext } from '../../../../model/common';
import { HandleWebParameterContextBeforeDBRequest, HandleServerContextAfterDBRequest } from "../../../../bizlogic/servicesbll";
import { GridBaseCase } from '../../grid/grid.base.case';
import { CommonService } from 'src/service/common.service';
declare var app;

@Component({
  selector: 'app-mz-history-clockin',
  templateUrl: './mz-history-clockin.component.html',
  styleUrls: ['./mz-history-clockin.component.scss']
})
export class MzHistoryClockinComponent extends GridBaseCase implements AfterViewInit,OnInit {
  data:Date;
  ch: any;//日历汉化配置
  Today = {
    day: null,
    month: null,
    year: null
  };
  isCheckOldDate = false;//是否选中过去的日子
  checkDate: any = new Date();//选中的日期
  monthDays = null;//月总天数
  monthVisitDays = null;//月考勤天数
  lateDate = null;//月迟到天数
  currentMonth = null;//初始化当前月份
  visitArray = [];//拜访天
  selectDay = null;//选中的天
  selectMonth = null;//选中的月份
  totalearyly:any = 0;//早退天数
  absenceDuty:any = 0;//缺勤天数
  /**
   * 所有日程
   */
  scheduleDate = [];
  scheduleDateString = "";

  /** 
   * 当前选中日程
  */
  currentSchedule = [];
  searchDate: any = null;//查询日期

  constructor(
    private msg: MessageclientService,
    private activaRouter: ActivatedRoute,
    private platform: Platform,
    private http: HttpCustomerService,
    private router: Router,
    public com: CommonService
  ) {
    super();
    const d = new Date();
    this.Today.year = d.getFullYear();
    this.Today.month = d.getMonth();
    this.Today.day = d.getDate();
    this.currentMonth = this.com.getNow.split("-")[0] + '-' +this.com.getNow.split("-")[1];
    this.monthDays = new Date(this.currentMonth.split("-")[0],this.currentMonth.split("-")[1],0).getDate();
    this.ch = {
      /** 每周第一天，0代表周日 */
      firstDayOfWeek: 0,
      /** 每周天数正常样式 */
      dayNames: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"],
      /** 每周天数短样式（位置较小时显示） */
      dayNamesShort: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      /** 每周天数最小样式 */
      dayNamesMin: ["日", "一", "二", "三", "四", "五", "六"],
      /** 每月月份正常样式 */
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"],
      /**每月月份短样式 */
      monthNamesShort: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
      today: '今天',
      clear: '清除'
    };
  }

  ngAfterViewInit() {
    const that = this;
    let date = {
      year: that.Today.year,
      month: that.Today.month + 1
    }
    // setTimeout(()=>{
    //   that.getSearchDate(date);
    // },100)
    that.timeOutSearchDate(date);
  }
  ngOnInit(){
    
  }

  /**
   * 获取日程列表
   */
  getScheduleList(loads) {
    const that = this;
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const type = that.activaRouter.snapshot.paramMap.get('type');
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();

    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    } else if (that.ConfigName) {
      body.ConfigName = that.ConfigName;
    }
    body.OpType = "query";
    body.ConfigType = "view";
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = PageName;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }

    // let startDate = that.currentMonth + "-" + "01" + " 00:00:00";
    // let endDate = that.currentMonth + "-" + that.monthDays + " 23:59:59";
    let _id = that.com.GetAccount.Id;
    if(type == "view"){
      _id = id;
    }
    body.RequestBody = JSON.stringify({ "a_SNStartDate": that.searchDate, "a_FK_SystemUser_ID": _id });
    // body.RequestBody= JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_SNEndDate": that.searchDate});
    body = HandleWebParameterContextBeforeDBRequest(body);
    if (!body.ResponseMessage.Success) {
      loads.dismiss();
      that.msg.Alert(body.ResponseMessage.ErrorMessage);
      return;
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      data = HandleServerContextAfterDBRequest(body, data);
      that.scheduleDate = [];
      loads.dismiss();
      if (data.ResponseMessage.Success) {

        // that.scheduleDate = data.Status.Datas;
        console.log(data);
        // that.absenceDuty=data.Status.AbsenceDuty;//缺勤天数
        // that.monthVisitDays = data.Status.NormalWorkDays;//出勤天数
        that.lateDate = data.Status.LateDays;//迟到天数
        that.totalearyly = data.Status.LeaveEarly;//早退天数

        data.Status.Datas.forEach(function (item) {
          let objfield = {};
            that.element.selectItemList.selectItem.forEach((element, index) => {
              if (element.bindingField) {
                objfield[element.bindingField] = item[element.field];
              }
            });
            that.scheduleDate.push(objfield);
        });
        that.getMonthNum();//计算出勤天数
      }
    }).catch(error => {
      loads.dismiss();
      console.log(error);
      that.msg.Alert(error.ResponseMessage.ErrorMessage);
      // that.msg.Alert(error.error.ResponseMessage.ErrorMessage).then(data => {
      //   //that.router.navigate(["/login"]);
      // })
    })
  }

  /**
* 下拉刷新数据
* @param event
*/
  //  doRefresh(event) {
  //   this.getScheduleList();
  //   event.target.complete();
  // }

  MonthchangeEvent(e){
    let that = this;
    this.currentMonth = e.year + '-' + (e.month < 10?'0'+e.month:e.month);
    this.monthDays = new Date(this.currentMonth.split("-")[0],this.currentMonth.split("-")[1],0).getDate();
    // this.getScheduleList();
    this.selectDay = null;

    // setTimeout(() => {
    //   that.getSearchDate(e);
    // },300)
    that.timeOutSearchDate(e);
  }

  //统计信息
  getMonthNum(){
    // return;
    let that = this;
    
    that.visitArray = [];
    let lateArray = [];
    that.scheduleDate.forEach((item,index)=>{
      if(that.DateFormat(item.date).indexOf(that.currentMonth) >= 0){
        if(item['startTime'] && item["entryTime"] && that.timeDifference(item['startTime'],item["entryTime"],180)){
          that.visitArray.push(item);
        }
      }
      
    });
    // 迟到天数
    // that.lateDate = lateArray.length;
    //出勤天数
    that.monthVisitDays = that.visitArray.length;
  }

  /**
   * 获取当天日程
   */
  getCurrentSchedule(day) {
    let that = this;
    that.currentSchedule = [];
    let d = this.DateFormat(day);
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(d) > -1) {
        that.currentSchedule.push(item);
      }
    })
  }


  /**
   * 获取每一天考勤记录
   */
  getCurrentDayData(day){
    let that = this;
    let currentDate = {};
    let d = this.DateFormat(day);
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(d) > -1) {
        currentDate = item;
        if(currentDate['startTime']){
          let d = new Date(currentDate['startTime'].replace(/-/g, '/'));
          currentDate['begin'] = (d.getHours()<10?"0"+d.getHours():d.getHours()) + ':' + (d.getMinutes()<10?"0"+d.getMinutes():d.getMinutes());
        }
        if(currentDate['entryTime']){
          let d1 = new Date(currentDate['entryTime'].replace(/-/g, '/'));
          currentDate['end'] = (d1.getHours()<10?"0"+d1.getHours():d1.getHours())+ ':' + (d1.getMinutes()<10?"0"+d1.getMinutes():d1.getMinutes());
        }
      }
    })
    return currentDate;
  }


  /**
   * 选中日期
   * @param ev 
   * @param d 
   */
  DateSelect(ev) {
    let that = this;
    that.checkDate = ev;
    const currrentDay = ev.split("/")[1];
    that.selectDay == currrentDay ? that.selectDay = null : that.selectDay = currrentDay;
    // console.log(that.currentMonth,'select');

    const d1 = new Date(ev.toString().replace(/-/g, "/"));
    let monthDom = document.getElementsByClassName("ui-datepicker-month");
    let cMonth = d1.getMonth() + "";
    if(monthDom.length > 0){
      cMonth = monthDom[monthDom.length-1]['innerText'].replace('月', '');
    }
    if ((d1.getMonth() + 1) != parseInt(cMonth)) {
      that.currentMonth = that.DateFormat(ev).split("-")[0] + '-' + that.DateFormat(ev).split("-")[1];
      that.monthDays = new Date(that.currentMonth.split("-")[0],that.currentMonth.split("-")[1],0).getDate();
      let date = {
        year: d1.getFullYear(),
        month: d1.getMonth() + 1
      }
      // setTimeout(()=>{
      //   that.getSearchDate(date);
      // },200)
      that.timeOutSearchDate(date);
      that.selectDay = null;
    }
    that.selectMonth = parseInt(that.currentMonth.split('-')[1]);
    

  }


  /**
   * 判断日期是否存在
   * @param day 
   */
  getSchedule(date) {
    let date1 = '';
    if (!date.year) { return false; } else {
      date1 = date.year + '-' + ((date.month + 1)<10? '0'+ (date.month + 1):(date.month + 1)) + '-' + (date.day < 10? '0'+date.day:date.day);
    }
    let isSchedule = false;
    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(date1) > -1) {

        isSchedule = true;
      }
    })
    return isSchedule;
  }


    /**
   * 判断日期是否迟到
   * @param day 
   */
  getLate(date) {
    let date1 = '';
    if (!date.year) { return false; } else {
      date1 = date.year + '-' + ((date.month + 1)<10? '0'+ (date.month + 1):(date.month + 1)) + '-' + (date.day < 10? '0'+date.day:date.day);
    }
    let isSchedule = false;
    this.scheduleDate.forEach(function (item, i) {
      if ((item.state == 2 || item.state == 4) && item.date && item.date.indexOf(date1) > -1) {
        isSchedule = true;
      }
    })
    return isSchedule;
  }


      /**
   * 判断日期是否存在考勤
   * @param day 
   */
  getClock(date) {
    let date1 = '';
    if (!date.year) { return false; } else {
      date1 = date.year + '-' + ((date.month + 1)<10? '0'+ (date.month + 1):(date.month + 1)) + '-' + (date.day < 10? '0'+date.day:date.day);
    }
    let isClock = false;
    this.scheduleDate.forEach(function (item, i) {
      if (item.state && item.state != 0 && item.date && item.date.indexOf(date1) > -1) {
        isClock = true;
      }
    })
    return isClock;
  }

  /**
   * 是否是过去的日期
   * @param date 
   */
  isOldDate(date) {
    
    if (date) {
      if (date.year < this.Today.year) {
        return true;
      } else if (date.year == this.Today.year) {
        if (date.month < this.Today.month) {
          return true;
        } else if (date.month == this.Today.month) {
          if (date.day < this.Today.day) {
            return true;
          }
        }
      }
    }
  }

  addPlan() {
    // this.router.navigateByUrl("/tabs/contact/PlanMakingList/add/"+this.DateFormat(this.checkDate));
    this.com.Go("/tabs/contact/PlanMakingList/add/"+this.DateFormat(this.checkDate));
  }

  /**
   * 格式化日期
   * @param date 日期
   */
  DateFormat(dateFormat) {
    let date = dateFormat;
    if (date) {
      date = new Date(date.toString().replace(/-/g,"/"));
    } else {
      return;
    }
    let y = date.getFullYear();
    let m = date.getMonth() + 1;
    if (m < 10) {
      m = '0' + m;
    }
    let d = date.getDate();
    if (d < 10) {
      d = '0' + d;
    }
    return y + '-' + m + '-' + d;
  }

  /**
   * 设置月份查询条件
   * @param date 
   */
  getSearchDate(date,loads) {
    const that = this;
    const d = date;
    let timerI = 0;
    let timer = setInterval(()=>{
      let domList:any = document.getElementsByClassName("ui-datepicker-calendar");
      timerI++;
      if(domList.length == 0){
        if(timerI < 10){
          return;
        }else{
          clearInterval(timer);
        }
      }else{
        clearInterval(timer);
      }
      
      let dom = null;
      const l = domList.length;
      if(l > 0){
        dom = domList[l-1];
      }else{}
      
      let timerI2 = 0;
      let timer2 = setInterval(()=>{
        const beginEle = dom.children[1].children[0].children[0];
        const endEle = dom.children[1].lastElementChild.lastElementChild;
        timerI2++;
        if(!beginEle && !endEle){
          if(timerI2 < 10){
            return;
          }else{
            clearInterval(timer2);
          }
        }else{
          clearInterval(timer2);
        }
        const beginDay = beginEle.children[0].children[0]['innerText'].replace(/(^\s*)|(\n*)|(\s*$)/g, "");
        const endDay = endEle.children[0].children[0]['innerText'].replace(/(^\s*)|(\n*)|(\s*$)/g, "");
        let beginMonth = beginEle.getAttribute("class").indexOf("ui-datepicker-other-month") >= 0 ? (d.month - 1) : (d.month);
        let endMonth = endEle.getAttribute("class").indexOf("ui-datepicker-other-month") >= 0 ? (d.month + 1) : (d.month);
        let beginYear = d.year;
        let endYear = d.year;
        if (beginMonth == 0) {
          beginMonth = 12;
          beginYear = d.year - 1;
        } else if (endMonth == 13) {
          endMonth = 1;
          endYear = d.year + 1;
        }
    
        const beginDate = beginYear + '-' + beginMonth + '-' + beginDay + ' 00:00:00';
        const endDate = endYear + '-' + endMonth + '-' + endDay + ' 23:59:59';
        this.searchDate = that.com.BetweenDate(beginDate, endDate);
        that.getScheduleList(loads);
      },400);
    },400);
  }


  getWorkState(date){
    let that = this;
    let text='';
    let date1 = '';
    if (!date.year) 
    { return text;  }
     else {
      date1 = date.year + '-' + ((date.month + 1)<10? '0'+ (date.month + 1):(date.month + 1)) + '-' + (date.day < 10? '0'+date.day:date.day);
    }

    this.scheduleDate.forEach(function (item, i) {
      if (item.date && item.date.indexOf(date1) > -1) {
         text= that.getWorkStateText(item);
        }
      })
      return text;
  }

  timeOutSearchDate(date){
    const that = this;
    that.msg.Loading("数据加载中...").then(loads=>{
      setTimeout(() => {
        that.getSearchDate(date,loads);
      },200);
      loads.present();
    })
  }

  /**
   * 计算时间差
   * @param beginTime 时间1 较小
   * @param endTime 时间2 较大
   * @param count 差值（单位分钟）
   */
  timeDifference(beginTime,endTime,count){
    let _begin = new Date(beginTime.replace(/-/g,"/")).getTime()/1000;
    let _end = new Date(endTime.replace(/-/g,"/")).getTime()/1000;
    let _count = parseInt(count)*60;
    if(Math.abs(_end -_begin)>_count){
      return true;
    }else{
      return false;
    }
  }
  getWorkStateText(item){
    if(item['startTime'] && item["entryTime"] && this.timeDifference(item['startTime'],item["entryTime"],180)){
      return "";
    }else{
      return "未"
    }
  }
  
}
function getWorkStateText(item) {
    let value=item.statecode;
    
    // if(item.statecode == 0 && item.state == "缺勤"){
    //   return "缺";
    // }
    // switch (value)
    // {
    //     case 0:
    //         // return "未上班";
    //         return "未";
    //     case 1:
    //         // if (item.entryTime == null || item.entryTime == "")
    //         // {
    //             // return "下班未打卡";
    //         // }
    //         // return "下班打卡异常";
    //         return "未";
    //     case 2:
    //         // if (item.entryTime == null || item.entryTime == "")
    //         // {
    //             // return "迟到、下班未打卡";
    //         // }
    //         return "迟";
    //     case 3:
    //         return "早";
    //     case 4:
    //         return "迟、早";
    //     case 5:
    //         // return "正常上下班";
    //         return "";
    //     case 6:
    //       // return "正常上下班";
    //       return "迟、未";
    // }
  }